import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const DIFFERENTIALS = [
  {
    icon: 'ri-time-line',
    title: 'Atendimento 24h',
    desc: 'Disponibilidade total para casos urgentes, a qualquer hora do dia ou da noite, incluindo finais de semana e feriados.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Ética & Estratégia',
    desc: 'Atuação pautada na ética profissional combinada com estratégias jurídicas elaboradas para cada caso específico.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Clareza Total',
    desc: 'Comunicação transparente sobre cada etapa do processo, para que você compreenda exatamente o que está acontecendo.',
  },
];

export default function DifferentialsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-bg-footer py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="font-cinzel font-bold text-navy text-3xl md:text-5xl lg:text-6xl leading-tight">
            Diferenciais que fortalecem
            <br />
            <em className="font-cinzel italic text-grey">sua defesa</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {DIFFERENTIALS.map((diff, i) => (
            <div
              key={i}
              className={`bg-off-white border border-navy rounded-2xl md:rounded-3xl p-6 md:p-8 transition-all duration-500 hover:-translate-y-1 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-14 h-14 rounded-full bg-navy flex items-center justify-center mb-5 transition-transform duration-300 hover:scale-110">
                <i className={`${diff.icon} text-white text-2xl w-full h-full flex items-center justify-center`} />
              </div>
              <h3 className="font-cinzel font-bold text-navy text-xl md:text-2xl">
                {diff.title}
              </h3>
              <p className="font-montserrat font-light text-grey text-sm md:text-base mt-3 leading-relaxed">
                {diff.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            Falar com o Advogado no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}